<svelte:options customElement="hb-auth" />

<script lang="ts">
  /**
   * Svelte Authentication WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */
  import { addComponent, LanguageTranslator } from "wc-js-utils";
  import pkg from "../../../package.json";
  import type { Component } from "./types/webcomponent.type";
  import type { Events as AuthSocialEvents } from "./types/webcomponent.type";

  import { dictionary } from "./libs/i18n";

  addComponent({
    repoName: "@htmlbricks/hb-auth-social-login-button",
    version: pkg.version,
  });

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  let {
    id = "",

    type = undefined,

    i18nlang = undefined,

    sessionkey = "_auth",
    social_auth_server_url = undefined,

    redirectonlogin = undefined,
    redirectoncreate = undefined,
    loginuri = undefined,
    registeruri = undefined,
    activateuri = undefined,
    recoveruri = undefined,
    requestmethod = undefined,
    appendqueryparams = undefined,
    appendbodyparams = undefined,
    logouri = "",
    oauth2providers = undefined,
    disableregister = undefined,
    disablelocal = false,

    passwordpattern = undefined,
    recoverycode = undefined,

    enable_recover_password = undefined,
    email = "",
  }: Component = $props();

  // export let expectmailconfirm: string;

  let checkValidity: boolean = $state(false);
  let rememberMe: boolean = $state(false);
  let passwordRepeated: string = $state("");
  let password: string = $state("");

  let recoveryCodeExists = $state(false);
  let translator: LanguageTranslator = $state(
    new LanguageTranslator({ dictionary, lang: i18nlang }),
  );

  let socialOAuthLoading = $state(false);
  let socialOAuthSuccess = $state(false);
  // onMount(() => {
  // 	translator = new LanguageTranslator({ dictionary, lang: i18nlang });
  // });
  $effect(() => {
    if (
      translator &&
      i18nlang &&
      translator.lang &&
      translator.lang !== i18nlang
    ) {
      translator = new LanguageTranslator({ dictionary, lang: i18nlang });
    }

    if (
      typeof enable_recover_password === "string" &&
      (enable_recover_password === "yes" ||
        enable_recover_password === "true" ||
        enable_recover_password === "")
    ) {
      enable_recover_password = true;
    } else if (!enable_recover_password) {
      enable_recover_password = false;
    }

    if (typeof oauth2providers === "string") {
      try {
        oauth2providers = JSON.parse(oauth2providers);
      } catch (err) {
        console.error("wrong oauth provider params");
        oauth2providers = undefined;
      }
    }
    if (oauth2providers && typeof oauth2providers === "object") {
      for (const prov of oauth2providers) {
        if (!prov?.url) {
          if (prov?.params && !prov.params.scope) {
            switch (prov.name) {
              case "facebook":
                prov.params.scope = "email";
                break;
              case "google":
                prov.params.scope =
                  "https%3A//www.googleapis.com/auth/userinfo.email";
                break;
              case "gitlab":
                prov.params.scope = "read_user";
                break;
              case "github":
                prov.params.scope = "user";
                break;

              default:
                break;
            }
          }
        }

        if (
          prov?.params?.redirect_url &&
          !prov.params.redirect_url.includes("provider=" + prov.name)
        ) {
          if (prov.params.redirect_url.includes("?")) {
            prov.params.redirect_url += "&provider=" + prov.name;
          } else {
            prov.params.redirect_url += "?provider=" + prov.name;
          }
        }
      }
    } else {
      oauth2providers = undefined;
    }

    if (
      !recoverycode &&
      location?.href &&
      location.href.split("recoverycode=").length > 1
    ) {
      recoverycode = location.href.split("recoverycode=")[1].split("&")[0];
      recoveryCodeExists = true;
    } else if (!recoverycode) {
      recoverycode = "";
    }

    if (
      !email &&
      location?.href &&
      location.href.split("recoveryemail=").length > 1
    ) {
      email = location.href.split("recoveryemail=")[1].split("&")[0];
    }
    if (
      !type &&
      location?.href &&
      location.href.split("recoverytype=").length > 1
    ) {
      type = location.href
        .split("recoverytype=")[1]
        .split("&")[0] as unknown as Component["type"];
    } else if (!type) {
      type = "login";
    }

    // validation
    checkValidity = false;

    // fetch request config

    if (!disableregister || (disableregister as unknown as string) === "no") {
      disableregister = false;
    }

    if (appendqueryparams) {
      if (loginuri)
        loginuri = loginuri
          .split("/")
          [loginuri.split("/").length - 1].includes("?")
          ? `${loginuri}&${appendqueryparams}`
          : `${loginuri}?${appendqueryparams}`;
      if (registeruri)
        registeruri = registeruri
          .split("/")
          [registeruri.split("/").length - 1].includes("?")
          ? `${registeruri}&${appendqueryparams}`
          : `${registeruri}?${appendqueryparams}`;
    } else {
      appendqueryparams = undefined;
    }

    if (!requestmethod) {
      requestmethod = "POST";
    } else {
      requestmethod = requestmethod.toUpperCase();
    }
    // i18n
    // if (!language || !dictionary[language]) {
    // 	const autolang = navigator?.languages ? navigator.languages[0]?.split("-")[0]?.toLowerCase() : undefined;
    // 	if (autolang && dictionary[autolang]) {
    // 		language = autolang;
    // 	} else {
    // 		language = "en";
    // 	}
    // 	localDictionary = dictionary[language];
    // } else {
    // 	localDictionary = dictionary[language];
    // }

    console.log(disableregister);
  });
  // function getCookie(cname: string) {
  // 	let name = cname + "=";
  // 	let decodedCookie = decodeURIComponent(document.cookie);
  // 	let ca = decodedCookie.split(";");
  // 	for (let i = 0; i < ca.length; i++) {
  // 		let c = ca[i];
  // 		while (c.charAt(0) == " ") {
  // 			c = c.substring(1);
  // 		}
  // 		if (c.indexOf(name) == 0) {
  // 			return c.substring(name.length, c.length);
  // 		}
  // 	}
  // 	return "";
  // }
  // console.log(getCookie(cookierequestkeys));

  function checkValidityFn(type: "password" | "email" | "passwordRepeated") {
    checkValidity = true;
    if (type === "email") {
      if (
        email?.length &&
        email.length > 3 &&
        email.split("@").length === 2 &&
        email.split(".")[email.split(".").length - 1]?.length > 1
      )
        return true;
    } else if (type === "passwordRepeated") {
      if (
        password.length &&
        password.length > 3 &&
        passwordRepeated === password
      )
        return true;
    } else if (type === "password") {
      if (password.length && password.length > 3) return true;
    }
    return false;
  }

  async function login() {
    if (checkValidityFn("email") && checkValidityFn("password")) {
      console.log("request");
      if (loginuri) {
        try {
          let response;
          if (requestmethod === "GET") {
            response = await fetch(`${loginuri}`, {
              method: requestmethod, // *GET, POST, PUT, DELETE, etc.
              // mode: "cors", // no-cors, *cors, same-origin
              cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
              // credentials: "same-origin", // include, *same-origin, omit
              headers: {
                "Content-Type": "application/json",
                // 'Content-Type': 'application/x-www-form-urlencoded',
              },
              redirect: "follow", // manual, *follow, error
              referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            });
          } else {
            let body = { email, password, rememberMe };
            if (appendbodyparams)
              Object.assign(body, JSON.parse(appendbodyparams));

            response = await fetch(`${loginuri}`, {
              method: requestmethod, // *GET, POST, PUT, DELETE, etc.
              // mode: "cors", // no-cors, *cors, same-origin
              cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
              // credentials: "same-origin", // include, *same-origin, omit
              headers: {
                "Content-Type": "application/json",
                // 'Content-Type': 'application/x-www-form-urlencoded',
              },
              redirect: "follow", // manual, *follow, error
              referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
              body: JSON.stringify(body), // body data type must match "Content-Type" header
            });
          }

          const serverAnswer = await response.json();
          const answer = serverAnswer;
          // answer.requestSent = { user, password, rememberMe, uri: loginuri };
          if (!answer.ok && !answer.token) {
            console.log(answer);
            throw new Error("invalid login");
          }

          if (rememberMe) setLoginOnStorage(JSON.stringify(answer));
          else setLoginSession(JSON.stringify(answer));

          if (redirectonlogin) location.href = redirectonlogin;
          dispatch("login", answer);
        } catch (err) {
          console.error(err);

          console.error("invalid login", { email, password, rememberMe });
        }
      } else {
        // const cookie = {
        // 	user,
        // 	password,
        // };
        // setLoginCookie(JSON.stringify(cookie));
        // if (redirectonlogin) location.href = redirectonlogin;

        dispatch("login", {
          email,
          password,
          rememberMe,
        });
      }
    } else {
      console.error("invalid login", { email, password, rememberMe });
    }
  }

  function setLoginOnStorage(tokenStringified: string, expire?: number) {
    if (sessionkey) localStorage.setItem(sessionkey, tokenStringified);
  }

  function setLoginSession(tokenStringified: string, expire?: number) {
    if (sessionkey) sessionStorage.setItem(sessionkey, tokenStringified);
  }
  async function register() {
    if (checkValidityFn("email") && checkValidityFn("password")) {
      if (registeruri) {
        try {
          let response;
          if (requestmethod === "GET") {
            response = await fetch(`${registeruri}`, {
              method: requestmethod, // *GET, POST, PUT, DELETE, etc.
              // mode: "cors", // no-cors, *cors, same-origin
              cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
              // credentials: "same-origin", // include, *same-origin, omit
              headers: {
                "Content-Type": "application/json",
                // 'Content-Type': 'application/x-www-form-urlencoded',
              },
              redirect: "follow", // manual, *follow, error
              referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            });
          } else {
            let body = { email, password };
            if (appendbodyparams)
              Object.assign(body, JSON.parse(appendbodyparams));

            response = await fetch(`${registeruri}`, {
              method: requestmethod, // *GET, POST, PUT, DELETE, etc.
              // mode: "cors", // no-cors, *cors, same-origin
              cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
              // credentials: "same-origin", // include, *same-origin, omit
              headers: {
                "Content-Type": "application/json",
                // 'Content-Type': 'application/x-www-form-urlencoded',
              },
              redirect: "follow", // manual, *follow, error
              referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
              body: JSON.stringify(body), // body data type must match "Content-Type" header
            });
          }
          const answer = await response.json();
          answer.ok = true;
          answer.requestSent = { email, password };
          const cookie = {
            email,
            password,
          };
          // setLoginCookie(JSON.stringify(cookie));

          if (redirectoncreate) location.href = redirectoncreate;
          dispatch("register", answer);
        } catch (err) {
          console.error(err);
          console.error("invalid register", {
            email,
            password,
            uri: registeruri,
          });
        }
      } else {
        // const cookie = {
        // 	user,
        // 	password,
        // };
        // setLoginCookie(JSON.stringify(cookie));
        // if (redirectoncreate) location.href = redirectoncreate;

        dispatch("register", {
          email,
          password,
        });
      }
    } else {
      console.error("invalid register", { email, password });
    }
  }

  function switchType(t: Component["type"]) {
    email = "";
    password = "";
    passwordRepeated = "";
    rememberMe = false;
    checkValidity = false;
    type = t;
  }
  //test@tt.com
  function recoverOrActivate() {
    checkValidity = true;

    if (
      recoverycode &&
      checkValidityFn("email") &&
      checkValidityFn("password") &&
      checkValidityFn("passwordRepeated")
    ) {
      dispatch("recoverOrActivate", { password, recoverycode, email });
    } else {
      console.error("wrong params", recoverycode, password, passwordRepeated);
    }
  }

  function recoverPassword() {
    checkValidity = true;

    if (checkValidityFn("email")) {
      dispatch("recoverPassword", { email });
    } else {
      console.error("wrong params", email);
    }
  }
  function keyupkboard(k: KeyboardEvent) {
    if (k.keyCode === 13) {
      switch (type) {
        case "login":
          return login();
        case "activate":
        case "recover":
          return recoverOrActivate();
        case "forgotpassword":
          return recoverPassword();
        case "register":
          return register();
      }
    }
  }
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap-icons@latest/font/bootstrap-icons.css"
  />
</svelte:head>
<!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
<div class="hb-auth__wrap">
  {#if socialOAuthSuccess && !socialOAuthLoading}
    <div class="notification is-success is-light mb-4" role="status">
      <button
        type="button"
        class="delete"
        aria-label={translator?.translateWord("dismissBanner")}
        onclick={() => {
          socialOAuthSuccess = false;
        }}
      ></button>
      {translator?.translateWord("oauthSocialSuccess")}
    </div>
  {/if}
  <div class="hb-auth__card-shell">
    <main
      class="hb-auth box"
      class:hb-auth--oauth-loading={socialOAuthLoading}
      aria-busy={socialOAuthLoading ? "true" : "false"}
      onkeyup={(k) => keyupkboard(k)}
    >
  <slot name="header">
    {#if logouri}
      <div class="hb-auth__header mb-4">
        <img id="logoimg" src={logouri} alt="" />
      </div>
    {/if}
  </slot>

  {#if type === "login"}
    <h1 class="hb-auth__title title is-4 has-text-centered mb-4">
      {translator?.translateWord("loginTitle")}
    </h1>
  {:else if type === "forgotpassword"}
    <h1 class="hb-auth__title title is-4 has-text-centered mb-4">
      {translator?.translateWord("ForgotTitle")}
    </h1>
  {:else if type === "register"}
    <h1 class="hb-auth__title title is-4 has-text-centered mb-4">
      {translator?.translateWord("registerTitle")}
    </h1>
  {:else if type === "activate" || type === "recover"}
    <h1 class="hb-auth__title title is-4 has-text-centered mb-4">
      {translator?.translateWord("recoverTitle")}
    </h1>
  {/if}
  {#if typeof oauth2providers === "object" && oauth2providers?.length}
    <div class="hb-auth__oauth">
      <ul
        class="social-icons is-flex is-flex-wrap is-justify-content-center is-gap-2"
      >
        {#each oauth2providers as p (p?.name)}
          <li>
            <hb-auth-social-login-button
              provider={JSON.stringify({
                name: p?.name,
                url: p?.url,
                params: p?.params,
              })}
              auth_cookie_name={sessionkey}
              {social_auth_server_url}
              {redirectonlogin}
              onoauthFlowRedirectStart={(e: {
                detail: AuthSocialEvents["oauthFlowRedirectStart"];
              }) => {
                socialOAuthSuccess = false;
                socialOAuthLoading = true;
                dispatch("oauthFlowRedirectStart", e.detail);
              }}
              onoauthFlowInit={(e: {
                detail: AuthSocialEvents["oauthFlowInit"];
              }) => {
                socialOAuthSuccess = false;
                socialOAuthLoading = true;
                dispatch("oauthFlowInit", e.detail);
              }}
              onoauthFlowSuccess={(e: {
                detail: AuthSocialEvents["oauthFlowSuccess"];
              }) => {
                socialOAuthLoading = false;
                socialOAuthSuccess = true;
                dispatch("oauthFlowSuccess", e.detail);
              }}
              onoauthFlowCustom={(e: {
                detail: AuthSocialEvents["oauthFlowCustom"];
              }) => {
                dispatch("oauthFlowCustom", e.detail);
              }}
            ></hb-auth-social-login-button>
          </li>
        {/each}
      </ul>
    </div>
    {#if !disablelocal}
      <hr class="hb-auth__divider my-4" />
      <h2 class="subtitle is-6 has-text-centered has-text-weight-semibold mb-4">
        {translator?.translateWord("credentialsTitle")}
      </h2>
    {/if}
  {/if}

  <div class="hb-auth__fields">
  {#if !disablelocal && (type === "login" || type === "register")}
    <div class="field">
      <label class="label" for="hb-auth-email">Email</label>
      <div class="control">
        <input
          id="hb-auth-email"
          type="email"
          autocomplete="email"
          class="input"
          class:is-success={checkValidity && checkValidityFn("email")}
          class:is-danger={checkValidity && !checkValidityFn("email")}
          bind:value={email}
          placeholder="name@example.com"
          required
        />
      </div>
    </div>
    <div class="field">
      <label class="label" for="hb-auth-password">Password</label>
      <div class="control">
        <input
          id="hb-auth-password"
          type="password"
          autocomplete={type === "login" ? "current-password" : "new-password"}
          class="input"
          class:is-success={checkValidity && checkValidityFn("password")}
          class:is-danger={checkValidity && !checkValidityFn("password")}
          placeholder="Password"
          bind:value={password}
          required
          pattern={passwordpattern ? passwordpattern : undefined}
        />
      </div>
    </div>
  {:else if type === "forgotpassword"}
    <div class="field">
      <label class="label" for="hb-auth-email-forgot">Email</label>
      <div class="control">
        <input
          id="hb-auth-email-forgot"
          type="email"
          autocomplete="email"
          class="input"
          class:is-success={checkValidity && checkValidityFn("email")}
          class:is-danger={checkValidity && !checkValidityFn("email")}
          bind:value={email}
          placeholder="name@example.com"
          required
        />
      </div>
    </div>
  {:else if type === "mailrecoverinfo"}
    <div class="field">
      <div class="content has-text-left">{translator?.translateWord("recoverEmailText")}</div>
    </div>
  {:else if type === "activate" || type === "recover"}
    <div class="field">
      <label class="label" for="hb-auth-recovery-code"
        >{translator?.translateWord("temporaryCode")}</label
      >
      <div class="control">
        {#if !recoveryCodeExists}
          <input
            id="hb-auth-recovery-code"
            type="text"
            class="input"
            placeholder="Codice temporaneo"
            bind:value={recoverycode}
            required
          />
        {:else}
          <input
            id="hb-auth-recovery-code"
            type="text"
            class="input"
            placeholder="Codice temporaneo"
            bind:value={recoverycode}
            disabled
          />
        {/if}
      </div>
    </div>
    <div class="field">
      <label class="label" for="hb-auth-email-recovery">Email</label>
      <div class="control">
        {#if !recoveryCodeExists || !email}
          <input
            id="hb-auth-email-recovery"
            type="email"
            autocomplete="email"
            class="input"
            class:is-success={checkValidity && checkValidityFn("email")}
            class:is-danger={checkValidity && !checkValidityFn("email")}
            bind:value={email}
            placeholder="name@example.com"
            required
          />
        {:else}
          <input
            id="hb-auth-email-recovery"
            type="email"
            class="input"
            class:is-success={checkValidity && checkValidityFn("email")}
            class:is-danger={checkValidity && !checkValidityFn("email")}
            bind:value={email}
            placeholder="name@example.com"
            disabled
          />
        {/if}
      </div>
    </div>
    <div class="field">
      <label class="label" for="hb-auth-new-password"
        >{translator?.translateWord("newPassword")}</label
      >
      <div class="control">
        <input
          id="hb-auth-new-password"
          type="password"
          autocomplete="new-password"
          class="input"
          class:is-success={checkValidity && checkValidityFn("password")}
          class:is-danger={checkValidity && !checkValidityFn("password")}
          placeholder="Password"
          bind:value={password}
          required
          pattern={passwordpattern ? passwordpattern : undefined}
        />
      </div>
    </div>
    <div class="field">
      <label class="label" for="hb-auth-repeat-password"
        >{translator?.translateWord("repeatPassword")}</label
      >
      <div class="control">
        <input
          id="hb-auth-repeat-password"
          type="password"
          autocomplete="new-password"
          class="input"
          class:is-success={checkValidity &&
            checkValidityFn("passwordRepeated")}
          class:is-danger={checkValidity &&
            !checkValidityFn("passwordRepeated")}
          placeholder="Ripeti password"
          bind:value={passwordRepeated}
          required
          pattern={passwordpattern ? passwordpattern : undefined}
        />
      </div>
    </div>
  {/if}

  {#if type === "login" && !disablelocal}
    <div class="field">
      <div class="control">
        <label class="checkbox">
          <input type="checkbox" bind:checked={rememberMe} />
          {translator?.translateWord("rememberMe")}
        </label>
      </div>
    </div>
    <button
      type="button"
      class="button is-primary is-medium is-fullwidth"
      onclick={() => login()}
      >{translator?.translateWord("loginButton")}</button
    >
    {#if enable_recover_password || !disableregister}
      <p
        class="hb-auth__footer-links mb-0 mt-3 is-flex is-justify-content-center is-align-items-center is-flex-wrap is-gap-1"
      >
        {#if enable_recover_password}
          <button
            type="button"
            class="button is-ghost is-link p-0"
            onclick={() => switchType("forgotpassword")}
            >{translator?.translateWord("forgotPasswordButton")}</button
          >
        {/if}
        {#if enable_recover_password && !disableregister}<span
            class="has-text-grey">/</span
          >{/if}
        {#if !disableregister}
          <button
            type="button"
            class="button is-ghost is-link p-0"
            onclick={() => switchType("register")}
            >{translator?.translateWord("registerButton")}</button
          >
        {/if}
      </p>
    {/if}
  {:else if type === "register" && !disablelocal}
    <div class="field mb-3"></div>
    <button
      type="button"
      class="button is-primary is-medium is-fullwidth"
      onclick={() => register()}
      >{translator?.translateWord("registerButton")}</button
    >
    <p class="hb-auth__footer-links mb-0 mt-3">
      <button
        type="button"
        class="button is-ghost is-link p-0"
        onclick={() => switchType("login")}
        >{translator?.translateWord("loginSwitch")}</button
      >
    </p>
  {:else if type === "mailrecoverinfo"}
    <p class="hb-auth__footer-links mb-0 mt-3">
      <button
        type="button"
        class="button is-ghost is-link p-0"
        onclick={() => switchType("login")}
        >{translator?.translateWord("loginSwitch")}</button
      >
    </p>
  {:else if type === "forgotpassword"}
    <div class="field mb-3"></div>
    <button
      type="button"
      class="button is-primary is-medium is-fullwidth"
      onclick={() => recoverPassword()}
      >{translator?.translateWord("recoverWord")}</button
    >
    <div class="hb-auth__footer-links mt-3">
      <button
        type="button"
        class="button is-ghost is-link p-0"
        onclick={() => switchType("login")}
        >{translator?.translateWord("loginSwitch")}</button
      >
    </div>
  {:else if type === "activate" || type === "recover"}
    <div class="field mb-3"></div>
    <button
      type="button"
      class="button is-primary is-medium is-fullwidth"
      onclick={() => recoverOrActivate()}
      >{translator?.translateWord("memo")}</button
    >
  {/if}
  </div>

  <!-- <p class="mt-5 mb-3 text-muted">&copy; 2017–2021</p> -->
    </main>
    {#if socialOAuthLoading}
      <div class="hb-auth__oauth-overlay" role="status" aria-live="polite">
        <span class="hb-auth__spinner" aria-hidden="true"></span>
      </div>
    {/if}
  </div>
</div>

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
